<template>
  <div
    class="space-y-4"
    data-test-id="review-snapshot-fit-rating"
  >
    <div v-for="(type, i) in fitRatings" :key="i">
      <p :id="`fit-rating-${i}`" class="capitalize">
        {{ type.name }}
      </p>
      <vf-meter
        v-if="type.display_values?.length"
        :aria-labelledby="`fit-rating-${i}`"
        :aria-valuetext="getFitRatingValues(type).label"
        data-test-id="review-snapshot-fit-rating-scale"
        :max-label="type.display_values[type.display_values.length - 1]"
        :max-value="type.display_values.length"
        :min-label="type.display_values[0]"
        :value="getFitRatingValues(type).value"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ProductReviewsRollupProperty } from '#root/api/clients/product/data-contracts'

defineProps<{
  fitRatings: ProductReviewsRollupProperty[]
}>()
</script>
